export default __webpack_public_path__ + "static/media/rotate-clockwise-icon.3b97a9b1.svg";